import { addYears, isBefore } from 'date-fns';

import { startOfDayUTC } from '@/utils';

export const isEligibleForFreeData = (deviceShipDate: string | null) => {
    const isShipDateProvided = !!deviceShipDate;
    if (!isShipDateProvided) {
        return true;
    }
    const startOfTodayUTC = startOfDayUTC(new Date());
    const shippedUtc = new Date(Date.parse(deviceShipDate));
    const lastDayToReceiveFreeData = startOfDayUTC(addYears(shippedUtc, 1));
    const isEligibleForFreeData = isBefore(startOfTodayUTC, lastDayToReceiveFreeData);

    return isEligibleForFreeData;
};
